import React from "react"
import PropTypes from "prop-types"
import Flatpickr from "react-flatpickr"
import { Spanish } from "flatpickr/dist/l10n/es.js"
import "flatpickr/dist/themes/material_red.css"

import { rangeDatePicker } from "helpers/functions"

/**
 * Selector de rango de fechas de una tarjeta. Se conserva Flatpickr —un rango
 * no se resuelve con dos `select`— pero revestido con `.res-period` para que
 * quede como el campo del diseño.
 */
const PeriodField = ({ periodo, onChange }) => (
  <div className="res-period">
    <Flatpickr
      className="form-control"
      options={{
        mode: "range",
        dateFormat: "Y-m-d",
        locale: Spanish,
        defaultDate: periodo.split("/"),
      }}
      onChange={fechas => {
        // Flatpickr dispara el cambio también al elegir la primera fecha del
        // rango; hasta que no hay dos no se puede consultar nada.
        if (fechas.length !== 2) return
        onChange(rangeDatePicker(fechas))
      }}
    />
    <span className="res-period-label">Periodo</span>
  </div>
)

PeriodField.propTypes = {
  periodo: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default PeriodField
